module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./RefundView.js"));
	}, "RefundView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RefundView!./src/pages/Shop/Member/Wallet/Refund/RefundView.js
// module id = 1063
// module chunks = 438